/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import {
  TypeRampV2,
  colors,
  MenuSeparator,
  sizes,
} from '@smartsheet/lodestar-core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  selectSchedules,
  selectIsUpsertScheduleVisible,
} from '../../../../../../services/ducks/schedulesDuck';
import { ListItem } from './ListItem';

const subContainerStyle = css`
  background-color: ${colors.neutralLight30};
  width: 100%;
  padding: ${sizes.medium}px;
  box-sizing: border-box;
`;

const menuSeparatorStyle = css`
  && {
    margin-top: ${sizes.xLarge}px;
    margin-bottom: ${sizes.xLarge}px;
  }
`;

const titleStyle = css`
  margin: 0;
  padding: 0;
  margin-bottom: ${sizes.small}px;
`;

export const ListSchedules = () => {
  const schedules = useSelector(selectSchedules);
  const { t: translate } = useTranslation();
  const isUpsertScheduleVisible = useSelector(selectIsUpsertScheduleVisible);
  return (
    <div>
      {Array.isArray(schedules) && schedules.length ? (
        <React.Fragment>
          {isUpsertScheduleVisible ? (
            <MenuSeparator css={menuSeparatorStyle} />
          ) : null}
          <TypeRampV2
            system="lodestar"
            variant="bodyText"
            css={titleStyle}
            renderAs="h5"
          >
            {translate('designer:triggerPanel:schedules:list:activeSchedules')}
          </TypeRampV2>
          <div css={subContainerStyle}>
            {schedules.map((schedule, index) => (
              <React.Fragment key={index}>
                <ListItem
                  scheduleIndex={index}
                  schedule={schedule}
                  isLastItem={index !== schedules.length - 1}
                />
              </React.Fragment>
            ))}
          </div>
        </React.Fragment>
      ) : null}
    </div>
  );
};
